import styled from 'styled-components';

export const ResultInfoWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  & .info-text {
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    color: #1d201f;
  }

  & .infoFade-enter {
    opacity: 0;
    transform: translateX(100%);
  }

  & .infoFade-enter-active {
    opacity: 1;
    transform: translateX(0);
    transition: 350ms ease;
  }

  & .infoFade-exit {
    opacity: 0;
    transform: translateX(-100%);
    transition: 350ms ease;
  }
`;
